let treeHelper = require('../../helpers/tree');
let exportColumnHelper = require('./export-column-helper');
let _ = require('lodash');

function setAll (originalPath, treePath, propertyName) {
    return function ({ value }, state) {
        treeHelper.setAllSelection(state, originalPath, treePath, value);
        // если выделяем всё в дереве, то отметим галку колонки
        if (value === true) {
            exportColumnHelper.setExportColumnIsChecked({ value, propertyName }, state);
        }
    }
}

module.exports = {
    initTreeState (args, state, originalPath, treePath) {
        treeHelper.initTreeUiState(state, originalPath, treePath);
    },

    changeValue ({ path, value }, state, originalPath, treePath, propertyName) {
        treeHelper.changeTreeNodeValue(
            state,
            originalPath,
            treePath,
            path,
            value);
        // если отметили что-то в дереве, то отметим галку в колонке
        if (value === true) {
            exportColumnHelper.setExportColumnIsChecked({ value, propertyName: propertyName }, state);
        }
    },

    setAll ({ value }, state, originalPath, treePath, propertyName) {
        let func = setAll(originalPath, treePath, propertyName);
        func({ value }, state);
    },

    tryUnsetSelected({ path }, state, originalPath, treePath, propertyName) {
        // если пользователь убрал галку с нашей колонки, то очистим дерево
        exportColumnHelper.tryUnsetAllSelected({ path, propertyName: propertyName,
            setAllFunction: setAll(originalPath, treePath, propertyName) }, state)
    },

    clearFilter (args, state, treePath, filterName) {
        treeHelper.clearFilter(state, treePath, filterName)
    },
};




// WEBPACK FOOTER //
// ./actions/custom-order/additional-tree.js